import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SubscriberSelectComponent } from '../subscriber-select/subscriber-select.component';

@Component({
    selector: 'app-subscriber-select-control',
    imports: [SubscriberSelectComponent],
    templateUrl: './subscriber-select-control.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: SubscriberSelectControlComponent,
		multi: true
	}]
})
export class SubscriberSelectControlComponent implements ControlValueAccessor {
    
    showClear = input<boolean>(true);
    includeInternalSubscriber = input<boolean>(false);

	subscriberKey = signal<number | null>(null);
	isDisabled = signal<boolean>(false);

	onSubscriberKeyChange(subscriberKey: number | null) {
		this.subscriberKey.set(subscriberKey);
		this.onChange(subscriberKey);
		this.onTouched();
	}

	onBlur() {
		this.onTouched();
	}

    protected onChange = (_: any) => {};
    protected onTouched = () => {};

    writeValue(obj: number | null): void {
        this.subscriberKey.set(obj);
    }
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.isDisabled.set(isDisabled);
    }
}
